import Vue from 'vue';

let timer = null;

Vue.directive('focus', {
    bind: function (el, binding) {
        // 聚焦元素
        if (binding.value) {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                el.focus();
            }, 100)
        }
    },
    // 当绑定元素插入到 DOM 中。
    // update: function (el, binding) {
    //     // 聚焦元素
    //     if (binding.value) {
    //         el.focus();
    //     }
    // }
});



// WEBPACK FOOTER //
// ./src/vdirectives/focus.js